import * as THREE from 'three';

export const applyQuarterCircleArcShape = (
    shape: THREE.Shape,
    width: number,
    depth: number
) => {
    const actualRadius = Math.min(depth, width);

    if (depth > width) {
        const arcCenterX = depth - actualRadius;

        shape.moveTo(depth, 0);
        shape.lineTo(0, 0);
        shape.lineTo(0, width);
        shape.lineTo(arcCenterX, width);
        shape.absarc(arcCenterX, 0, actualRadius, Math.PI / 2, 0, true);
    } else {
        const arcCenterY = width - actualRadius;

        shape.moveTo(0, width);
        shape.lineTo(0, 0);
        shape.lineTo(depth, 0);
        shape.lineTo(depth, arcCenterY);
        shape.absarc(0, arcCenterY, actualRadius, 0, Math.PI / 2, false);
    }
};
